// extracted by mini-css-extract-plugin
module.exports = {"container":"_a8","title":"_a9","text":"_ba"};